<template>
    <nav v-if="last > 1" class="pagination is-centered" role="navigation" aria-label="pagination">
        <a @click="prev()" href="javascript:{}" class="pagination-previous" :disabled="current <= 1"><i class="fa fa-chevron-left"></i></a>
        <a @click="next()" href="javascript:{}" class="pagination-next" :disabled="current >= last"><i class="fa fa-chevron-right"></i></a>
        <ul class="pagination-list">
            <li @click="page(1)"><a class="pagination-link" aria-label="Goto page 1" v-if="current > 2">1</a></li>
            <li><span class="pagination-ellipsis" v-if="current > 2 && last > 4">&hellip;</span></li>
            <li @click="prev()"><a class="pagination-link"  v-if="current > 1">{{current - 1}}</a></li>
            <li><a class="pagination-link is-current" aria-current="page">{{current}}</a></li>
            <li  @click="next()"><a class="pagination-link" v-if="current < last - 1">{{current + 1}}</a></li>
            <li><span class="pagination-ellipsis" v-if="current < last  && last > 4">&hellip;</span></li>
            <li  @click="page(last)"><a class="pagination-link" v-if="current < last">{{last}}</a></li>
        </ul>
    </nav>
</template>

<script>
export default {
    name: 'bulma-pagination',
    props: {
      last: { required: true },
      current: {required: true}
    },
    data () {
      return {          
      }
    },
    methods: {
        next(){
            this.page(this.current + 1);
        },
        prev(){
            this.page(this.current - 1);
        },
        page(page){
            if(page > 0 && page <= this.last) {
                //this.current = page;
                this.$emit("change", page);
            }
        }
    },
    mounted () {

    },
    watch:{
        last: function(value){
            this.current = 1;
        }
    },
    computed: {

    }
}
</script>



// WEBPACK FOOTER //
// src/components/util/BulmaPagination.vue